import React from 'react'
import logoLight from '@assets/icons/logo.png'
import logoDark from '@assets/icons/logo-dark.png'
import './loadingScreen.scss'

/**
 * LoadingScreen — premium branded splash shown during app boot and lazy-route
 * resolution. Matches the inline splash in public/index.html so the brand moment
 * is identical whether painted before the bundle or by React afterwards.
 *
 * Design: the full-color logo floats free on a soft light brand backdrop (no card
 * box) so the wordmark always reads. A gentle gold halo breathes behind it and a
 * champagne shimmer sweeps across the logo.
 *
 * Animation (CSS-only, GPU-friendly transform/opacity):
 *   0–850ms  → logo fades + scales up + lifts (spring settle)
 *   ~550ms   → tagline fades up (staggered)
 *   ~650ms   → champagne shimmer sweeps across the logo (repeats gently)
 *   loop     → soft halo breathes behind the logo
 *
 * Performance: fetchpriority="high" + width/height preserved for LCP / no CLS.
 * No JS animation libs. Honors prefers-reduced-motion.
 */
const LoadingScreen = () => {
  // Dark mode uses the cream-text lockup: the standard black "STUDIER" is
  // unreadable on the dark backdrop. data-theme on <html> is set before first
  // paint by the inline script in public/index.html — keep the two in sync.
  const isDark =
    typeof document !== 'undefined' &&
    document.documentElement.getAttribute('data-theme') === 'dark'
  const logo = isDark ? logoDark : logoLight

  return (
    <div className='LoadingScreen'>
      <div className='LoadingScreen__inner'>
        <span className='LoadingScreen__aura' aria-hidden='true' />
        <div className='LoadingScreen__logobox'>
          <img
            className='LoadingScreen__logo'
            src={logo}
            alt='StudierAI'
            width={2234}
            height={827}
            fetchpriority='high'
          />
          <span className='LoadingScreen__shimmer' aria-hidden='true' />
        </div>
        <p className='LoadingScreen__tagline'>
          La prima AI che simula il tuo esame orale
        </p>
      </div>
    </div>
  )
}

export default LoadingScreen
